#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-09-16 16:18+0300\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: et\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {sõlm} other {sõlme}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{0}/{1} faili üles laaditud"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} kustutatakse jäädavalt."

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {salvestusämber} other {salvestusämbrit}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "{resourceTypeName} ID-ga {id} ei leitud"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 füüsiline server"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 päev"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 tund"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "10-kohaline TrueMoney mobiilinumber, mis algab numbriga 0"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 päeva"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "4 nädalat"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 tundi"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 päeva"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "Kõigile selle arvelduskonto all olevatele teenustele on rakendatud soodustus."

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "Selle kasutajanimega luuakse kasutajakonto. Sellega saab virtuaalmasinasse sisse logida. Võib sisaldada ASCII-tähti, numbreid, allkriipse ja sidekriipse. Peab algama tähe või allkriipsuga. Maksimaalne pikkus on 25 märki."

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "Virtuaalne privaatvõrk (VPC) on teie ressursside kogumile mõeldud privaatne võrguliides. VPC-võrk on saadaval lisatasuta."

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "Võta vastu"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "Võta kutse vastu"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "Vastu võetud"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "Selle ligipääsukutse vastuvõtmine annab teile õiguse tegutseda „{name}” nimel ja teha kõik toimingud kasutaja nimel."

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "Ligipääs"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "Ligipääsutunnused"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "Ligipääsu delegeerimine"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "Ligipääsurühm"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "Teiega on jagatud ligipääsu"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "Ligipääsukutse"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "Ligipääsukutse kasutajalt {0} on ootel"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "Juurdepääsuvõtme ID"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "Ligipääsu nimi"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "Ligipääsu ulatus"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "Ligipääsu tüüp"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "Tegutse kasutajana"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "Konto andmeid kinnitatakse."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "Konto andmed tuleb kinnitada"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "Konto ID"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "Konto nimi"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "Tegutse"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "Tegutsete kasutajana <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "Vajalik on teie tegevus"

#. Disk status
#. Service status
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "Aktiivne"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "Teie salvestuse tegelik kulu arvutatakse tunnipõhiselt vastavalt tegelikule kasutusele; ettemakseid ei ole. Iga alustatud GB eest ümardatakse hind üles järgmise täis-GB-ni."

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "Tegelik hind sõltub arvutus- ja salvestusruumi kasutusest. Talveunne pandud klastrite püsivate köidete eest tuleb endiselt tasuda. Täpsema teabe saamiseks vaadake arvelduskonto praegust kasutust."

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "Lisa"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "Lisage automaatset saldotäiendamist toetav makseviis."

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "Lisa täiendav ketas"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "Lisage vähemalt üks edastamisreegel"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "Lisage vähemalt üks sihtserver"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "Lisa virtuaalmasinale kohandatud konfiguratsioon"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "Lisa eesnimi"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "Lisa IP"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "Lisa perekonnanimi"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "Lisa nimi"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "Lisa uus makseviis..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "Lisa uus broneering"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "Lisa uus reegel"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "Lisa sõlm"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "Lisa node pool"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "Lisa makseviis"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "Lisa makseviis hiljem"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "Lisa reegel"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "Lisa SSH-võti"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "Lisa alamliides"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "Lisa sihtserver"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "Lisa kasutaja"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "Lisa kasutajaid"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "Makseviisi lisamine ebaõnnestus"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "Aadress"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "Aadressi rida 2"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "Administraatorivaade"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "Kõik"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "Kõik IP-aadressid"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "Kõik õigused"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "Kõik TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "Kõik UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "Eraldage ujuv IP-aadress ja hakake oma võrku haldama."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "Eraldatud"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "Uue IPv4-aadressi eraldamine võimaldab selle määrata ühele olemasolevale ressursile või reserveerida hilisemaks kasutuseks."

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "Kas teil on juba konto?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "Summa"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "Ettemaksuna arveldatav summa"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "Summa on liiga väike"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "Summa peab olema positiivne"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "Summa ei tohi olla väiksem kui minimaalne saldo täiendamise summa"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "Ressursside loomiseks on vaja aktiivset arvelduskontot."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "Selle funktsiooni kasutamiseks on vaja aktiivset arvelduskontot."

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "Teile on saadetud juhistega e-kiri."

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "Tekkis tõrge"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "Kõik"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "API dokumentatsioon"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "API-märgis"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "Rakenduste kataloog"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "Välimus"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "Taotle arvega tasumist"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "Kas soovite kindlasti kustutada alamliidese, mille UUID on {ifUuid}?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "Kas soovite kindlasti kustutada avalikku võtit \"{name}\"?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "Kas soovite kindlasti välja logida?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "Määra"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "Määratud"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "Määratud"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "Vähemalt üks e-posti aadress on nõutav"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "Vajalik on vähemalt üks IP-aadress"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "Vähemalt ühel node poolil peab autoskaleerija minimaalne väärtus olema 1 või rohkem."

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "Seosta tulemüür"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "Seo ressurss"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "Ühendatud"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "Ühendatud ressursiga"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "Automaatne"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "Automaatuuendus"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "Automaatne makse"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "Automaatne saldo täiendamine"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "Süsteemitaseme automaatsed varukoopiad on lubatud. Kasutage varunduskujutisi teenuse taastamiseks. Varukoopiaid säilitatakse 7 päeva, mis tähendab, et alles hoitakse 7 viimast varukoopiat."

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "Automaatsed süsteemitaseme varukoopiad on lubatud. Kasutage varukoopiatõmmiseid virtuaalmasina taastamiseks või looge varukoopiast uus muudetud suuruseparameetritega virtuaalmasin."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "Automaatuuendused ei uuenda eelvaateversioone."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "Täienda automaatselt (min. <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "Autoskaleerija maks."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "Autoskaleerija min."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "Saadaval"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "Ärgake"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "Tagasi"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "Tagasi oma kontole"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "Varukoopiad"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "Saldo ajalugu"

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Füüsilised serverid"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "Füüsiline server"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "Baasvaluuta"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "Alustage arvelduskonto kinnitamise protsessi."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "All on näide selle alamliidese seadistamisest Linuxi serveris."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "Arveldatud"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "Arveldus"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "Arvelduskonto"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "Arvelduskontol \"{title}\" on allahindlus {discount_percentage}%"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "Arvelduskonto on piiratud"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "Arvelduskonto nimi"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "Arvelduskonto ülekirjutus"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Billing account suspended"
msgstr "Arvelduskonto on peatatud"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "Arvelduskonto kinnitamine lükati tagasi"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "Arvelduskontod"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "Arveldustsükkel"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "Alglaadimisketas"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "Käivita ISO-andmekandjalt"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "Alglaadimisrežiim"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "Käivitamine on võimalik ainult siis, kui virtuaalmasin on peatatud."

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "{gatewayName}"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "Saldot täiendades nõustute <0>tingimustega</0>, <1>privaatsuspoliitikaga</1> ja <2>tagasimaksepoliitikaga</2>."

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "Varunduse keelamisel ei tehta teie virtuaalmasinast edaspidi automaatseid varukoopiaid. Seni tehtud varukoopiad säilivad ja saate neid endiselt kasutada. Varunduse saate vajadusel hiljem uuesti lubada."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "Valides „Globaalne”, saab ligi kõigile selle kasutajakonto ressurssidele. Kasutage „Globaalne” ulatust ettevaatusega."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "Valides „Piiratud”, piiratakse ligipääs valitud arvelduskontole kuuluvatele ressurssidele."

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "Registreerudes nõustute <0>kasutustingimustega</0>"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "Kampaaniakood"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "Antud juurdepääs"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "Tühista"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "Tühista üleslaadimised"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "Tühistatud"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "Kaardinumber"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "Kaardi kinnitamine ebaõnnestus"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "Muuda"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "Muuda parooli"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "Muutke oma parool, klõpsates kinnituse lingil, mille just saatsime teie postkasti."

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "Parooli muutmine ebaõnnestus"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "Parooli saab muuta ainult siis, kui virtuaalmasin töötab."

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "Valige uuele ressursile arvelduskonto, et koondada ressursid sobiva makseviisi alla."

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "Valige arvelduskonto, millele soovite ligipääsu jagada"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "Valige ressurss, millele IP määrata, või jätke see määramata. Saate IP hiljem alati sobivale ressursile määrata"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "Valige virtuaalmasin, mille külge ketas ühendada, või jätke see lahti ühendatuks ja ühendage see virtuaalmasinaga hiljem."

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "Valige oma ressursile VPC-võrk olemasolevate hulgast või looge uus privaatvõrk."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "Valige arvelduskonto"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "Vali meetod"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "Valige VPC-võrk, milles sihtserverid asuvad."

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "Valige UEFI, kui imporditav virtuaalmasin seda nõuab."

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "Linn"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "Puhastamine"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "Kustuta kõik"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "Tühista ülekirjutus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "Tühjenda üleslaadimised"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "PayPaliga ühendamiseks klõpsake nuppu."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "Klooni"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "Klooni ressurss"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "Sulge"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "Kood:"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "Ettemakstud"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "Ettevõtte nimi"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "Ettevõtte RNE-number"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "Mahukas API-juhend koos koodinäidetega on saadaval siin:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "Arvutus"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "Seadista ise"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "Kinnita e-posti aadress"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "Kinnita parool"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "Kinnitage oma e-posti aadress, klõpsates kinnituse lingil, mille just saatsime teie postkasti."

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "Kinnitus"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "Ühenda"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "Ühendage esmalt PayPaliga"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "Ühendamine"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "Makseviisi ühendamine"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "Ühenduse andmed"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "Kontaktisiku nimi"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "Kontaktisiku telefon"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "Võtke ühendust toega"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "Jätka"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "Kopeeritud!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "Kopeeri"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "Kopeeri konfiguratsioon lõikelauale"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "Kopeeri avalik URL"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "Kopeeri lõikelauale"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "Põhiteenused"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "Riik"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "Maakond"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "Loo"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "Loo"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "Looge esmalt arvelduskonto, seejärel saate hakata ressursse looma."

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "Looge pühendatud füüsiline server ja käitage oma rakendust maksimaalse jõudlusega."

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "Loo uus {resourceTypeName}"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "Looge uus ligipääs, et võimaldada teistel kasutajatel või süsteemidel teha toiminguid selle {siteName} kontoga."

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "Looge uus ketas ja hakake oma andmeid talletama."

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "Looge uus ressurss ja käivitage oma teenused minutitega."

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "Loo uus ressurss ja alusta oma võrgu haldamist."

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "Loo uus teenus ja käivita see mõne minutiga."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "Looge uus salvestuskonto, looge mõned salvestusämbrid ja alustage oma andmete skaleeritavat salvestamist – maksate vastavalt kasutusele."

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "Looge uus salvestuskonto, looge salvestusämbrid ja alustage oma andmete salvestamist."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "Looge uus virtuaalmasin või valige midagi rakenduste kataloogist, et käivitada oma teenused minutitega."

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "Looge isiklik VPC ja hakake oma võrke haldama."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "Loo ressursile avalik IPv4-aadress"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "Looge oma töökoormuste jaoks täiendavat salvestusruumi. Seadistage ketas ja ühendage see virtuaalmasinaga kohe või hiljem."

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "Loo konto"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "Looge meie API kasutamiseks API‑märgis."

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "Loo veel üks {0}"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "Loo arvelduskonto"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "Loo uus"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "Loodud"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "Loodud"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "Loomiskuupäev"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "Loomise alus"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "Luuakse"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "API-märgise abil ligipääsu loomine annab teile võtme meie API kasutamiseks."

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "Krediit"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Credit is added to this billing account automatically once the payment is received. Make sure the billing account ID is entered correctly."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "Krediiditeatis {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "Praegune"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "Praegune arveldustsükkel"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "Praegused muudatused hüljatakse."

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "Praegune kasutus"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "Praegu pole saadaval"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "Kohandatud"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "Kohandatud ISO-tõmmis"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "Klienditugi"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "Tume"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "Töölaud"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "Andmekeskus, kus ressurss asub"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "Andmekeskus, kus ressurss luuakse."

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "Andmed puuduvad"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "Kuupäev"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "Tagasi lükatud / peatatud"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "Vaikimisi"

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "Delegeeri ligipääs kasutajale"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "Delegeerige ligipääs oma kasutaja- või arvelduskontole, et usaldatud kasutajad saaksid teie ressursse hallata."

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "Delegeeri uus ligipääs"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "Ligipääsu delegeerimine valitud usaldusväärsele kasutajale võimaldab tal tegutseda teie nimel ning teha kõik toimingud teie kasutaja- või arvelduskonto nimel."

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "Kustuta"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "Kustuta ujuv IP-aadress"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "Kustutatud"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "„{display_name}” kustutamine eemaldab selle jäädavalt ning sellele ei pääse enam ligi."

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "„{display_name}” kustutamine hävitaks ressursi, mille eest on juba tasutud. Abi saamiseks võtke ühendust kasutajatoega."

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "„{name}” kustutamine eemaldab jäädavalt kõigi selle rühma kasutajate õiguse tegutseda teie nimel."

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "Kustutamine {count} {0, plural, one {item} other {items}}."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "Varukoopia kustutamine eemaldab selle jäädavalt."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "Arvelduskonto \"{title}\" kustutamine eemaldab selle jäädavalt. Arvelduskonto saab kustutada ainult siis, kui sellega pole seotud tasumata ressursse ja kui sellel pole kasutamata krediiti."

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "Makseviisi \"{0}\" kustutamine eemaldab selle arvelduskontolt."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "Teenuse kustutamisel kustutatakse ka teie varukoopiad ning teenust ei saa pärast seda taastada."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "Hetktõmmise kustutamine eemaldab selle jäädavalt."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "Juurdepääsuvõtme \"{accessKey}\" kustutamine eemaldab selle jäädavalt ja pärast seda ei saa seda enam salvestuse API-le juurdepääsuks kasutada."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "Krediitkaardi \"{placeholder}\" kustutamine eemaldab selle arvelduskontolt jäädavalt."

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "Ketta kustutamine eemaldab selle jäädavalt ja sellele ei saa enam juurde pääseda."

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "Ujuva IP-aadressi „{0}” kustutamine eemaldab selle teie kontolt ja vabastab selle üldisesse aadressifondi."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "Arvega tasumise makseviisi kustutamine eemaldab selle arvelduskontolt jäädavalt."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Teenuse „{display_name}” kustutamine eemaldab selle jäädavalt ning see ei ole pärast seda enam kättesaadav."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "Salvestuskonto \"{title}\" kustutamine eemaldab selle jäädavalt ja kustutab kõik seotud võtmed. Aktiivsete salvestusämbritega kontosid ei saa kustutada."

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "Salvestusämbri \"{name}\" kustutamine eemaldab selle jäädavalt ning selles olevatele failidele ei pääse pärast seda enam juurde."

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "Märgise „{description}” kustutamine eemaldab selle jäädavalt ja seda ei saa pärast seda autentimiseks kasutada."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Virtuaalmasina \"{name}\" kustutamine eemaldab selle jäädavalt ning sellele ei pääse enam ligi."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "Virtuaalmasina kustutamisel kustutatakse ka teie varukoopiad ja hetktõmmised ning masinat ei saa seejärel taastada. Kui soovite varukoopiad ja hetktõmmised alles jätta, kaaluge selle asemel masina peatamist."

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "VPC-võrgu „{name}” kustutamine eemaldab selle teie kontolt."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "Kirjeldus"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "Sihtkohad"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "Ühendamata"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "Keela"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "Keela varundus"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "Keela MFA"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "Keelatud"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "Katkesta ühendus"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "Pole ühendatud"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "Soodustus"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "Ketas"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "Ketta I/O"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "Ketta suurust saab ainult suurendada. Seda toimingut ei saa tagasi võtta. Minimaalne ketta suurus:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "Kettad"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "Kuvatav valuuta"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "Kuvatav nimi"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "Dokument"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "Dokumendifail"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "Dokumendi nr."

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "Laadi alla"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "Laadi alla konfiguratsioonifail"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "Laadi alla PDF"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "Lohistage failid siia"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "Maksetähtaeg"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "E-post"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "Muuda"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "Muuda „{title}”"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "Muuda hooldust"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "Muuda nime"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "Muuda sõlme"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "Muuda reeglit"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "E-post"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "E-posti domeen ei ole lubatud"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "E-posti aadressi kinnitamine ebaõnnestus"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "E-posti aadress kinnitatud"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "E-posti aadress, kuhu saadetakse arved ja aruanded."

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "Tühi ketas (ISO-käivitamiseks)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "Luba"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "Luba MFA"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "Võimaldage teistel kasutajatel või süsteemidel teha toiminguid selle kontoga seotud ressurssidega."

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "Lubatud"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "Lõppkuupäev"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "Lõpp-port"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "Lõpp-port peab olema alguspordist suurem"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "Lõppenud"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "Sisestage väärtus vahemikus 1 kuni 4094"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "Sisestage ainult numbreid"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "Sisestage saldo täiendamise summa valuutas {0} (vähemalt {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "Viga"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "Viga makseviisi lisamisel"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "Veakood: {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "Tõrge toimingu sooritamisel"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "Muudatuste salvestamisel tekkis viga"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "Hinnanguline maksumus varukoopia kohta"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "Hinnanguline kuukulu"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "Hinnanguline kokku"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "Hinnanguline maksumus"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "Eeldatav hind varukoopia kohta on {priceWithDiscount} kuus."

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "Eeldatav hind hetktõmmise kohta on {priceWithDiscount} kuus."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "Iga uus kasutaja saab {c_totalReceiverCredit} väärtuses tasuta krediiti, kui ta registreerub soovituslingi või -koodi kaudu ja lisab kinnitatud makseviisi."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "Iga uus kasutaja, kes registreerub soovitamisprogrammi kaudu ja täiendab saldot vähemalt {c_minimumTopUp}, saab boonuse {c_totalReceiverCredit} krediidi väärtuses."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "Näide"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "Vahetuskurss"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "Ilma {vatSymbol}-ta"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "Varusõlmed"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "Serveriga ühenduse loomine ebaõnnestus"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "Digio teegi laadimine ebaõnnestus"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "PayPali teegi laadimine ebaõnnestus"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "Hüpikakna avamine ebaõnnestus, võimalik, et hüpikakende blokeerija on sisse lülitatud"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "Fail"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "Failid"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "Failid laaditakse üles asukohta"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "Tulemüür"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "Tulemüür on saadaval lisatasuta."

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "Tulemüüri nimi"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "Tulemüür on nüüd saadaval"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "Eesnimi"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "Lipud"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "Ujuv IP-aadress"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "Kaust"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "Kausta nimi"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "Iga uue kasutaja eest, kes registreerub soovitamisprogrammi kaudu ja täiendab saldot vähemalt {c_minimumTopUp}, saate {c_promoterCredit} väärtuses tasuta krediiti."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "Iga uue kasutaja eest, kes registreerub teie soovituskoodi abil ja lisab kinnitatud makseviisi, saate tasuta krediiti väärtuses {c_promoterCredit}."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "Jooksva arvelduse kontode puhul saate makseviisi valida pärast konto loomist ja kinnitamist."

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "Hetktõmmiste eest tasute ainult hetktõmmise kasutatava salvestusruumi eest."

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "Peata jõuga"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "Unustasite parooli"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "Edastamisreeglid"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "Tasuta"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "Sagedus"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "alates"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "Allikas"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "Täielik tee"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "Täielikult hallatud andmebaas, et saaksite keskenduda oma koodile."

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "Täishallatud teenused – hoolitseme alusinfrastruktuuri ettevalmistamise ja teenuse halduse eest."

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "Tulevane"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "Värav"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB ketast"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB RAM-i"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "Genereeri (soovitatav)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "Genereerige API-ligipääsu märgis meie <0>API</0> kasutamiseks."

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "Globaalne"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "Mine töölauale"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "GST number"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "Tere"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "Tere, maailm!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "Hibernate"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "Hiberneeritud"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "Hiberneerib"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "Peida"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "Peida üksikasjad"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "Kõrge töökindlusega koormusjaotur jaotab liiklust samas andmekeskuse asukohas olevate virtuaalmasinate vahel."

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "tund"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "Tunnipõhine"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "Ainult tunnipõhine arveldustsükkel"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "Käesoleva arveldusperioodi kasutus uuendatakse iga tunni järel."

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "Saadud juurdepääs"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "Olen lugenud ja nõustun <0>kasutustingimustega</0>"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "Olen teadlik, et kustutamine on pöördumatu"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "Kui madala saldo teavitused on aktiivsed ja saldo langeb alla lävendi, teavitatakse teid."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "Kui aktiivne broneering lõpeb ja seda ei uuendata, rakendatakse tavapärast tunnipõhist hinnastamist."

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "Kui arvega tasumise makseviis ei aktiveeru kohe, võtame teiega üksikasjade täpsustamiseks ühendust. Kui te ei saa meilt peagi e-posti või arvega tasumine ei muutu aktiivseks, saate meiega ühendust võtta aadressil <0/>."

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "Kui teil on küsimusi, olete leidnud vea või soovite uut funktsiooni, võtke julgelt meiega ühendust <0>tugiteenuse</0> kaudu."

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "Kõigis arvutustes kasutatakse täpset tundide arvu: kuus 730, kvartalis 2190 ja aastas 8760."

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "Kasutuses"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "Mitteaktiivne"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "sissetulev"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "Sissetulevad reeglid"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "Sisaldub virtuaalmasina hinnas"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "Sissetulev liiklus on lubatud ainult määratud allikatest määratud portidesse. Kogu muu liiklus blokeeritakse."

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "Kirjeldav nimi. Seda kasutatakse ka virtuaalmasina sobiva hostinime genereerimiseks (kui asjakohane)."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "Infrastruktuur"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "Initsialiseerimisskript"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "Sisesta kood"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "Sisestage selle {siteName} kasutaja e-posti aadress, kellele soovite ligipääsu delegeerida. Kasutaja peab kutse oma profiilivaates vastu võtma."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "Ebapiisav saldo"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "Integratsiooni ID"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "Vigane kuu"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "Vigane vastus serverist. Stormwall blokeeris."

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "Vale vastuse tüüp serverist: JSON-i asemel saadi {ct}."

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "Registreerimine ebaõnnestus. Konto võib juba olemas olla."

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "Vigane aasta"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Invoice"
msgstr "Arve"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "Arve {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "Arve andmed"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "Arvete e-posti aadress"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "Arve on tasutud"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "Arvet ei saa tasuda"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "Arve nimi"

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "Arved"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "IP-aadress"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "IP-aadress või CIDR-vahemik"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "Lubatud IP-aadresside loend"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "IP-prefiksid"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "IP vahemik"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "IPv4 vahemik"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "IPv6 vahemik"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "Käivita ISOlt"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "Väljastamiskuupäev"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "Väljastatud"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "Säilita ujuv IP-aadress"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "Pidage meeles, et kõiki toiminguid logitakse ja need on teie juurde jälgitavad."

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "Võtme nimi"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Kubernetese paigaversioon"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Kubernetese paigaversiooni automaatuuendus"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Kubernetesi teenust ei saa luua."

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "Keel"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "Viimati muudetud"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "Perekonnanimi"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "Viimane varukoopia"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "Viimane hetktõmmis"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "Vähem üksikasju"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "Hele"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "Piirang eemaldatakse, kui saldo täiendamise kogusumma jõuab summani <0/>."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "Piiratud"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "Seotud ressursid"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "nimekirja hind"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "Koormusjaotur"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "Laadi veel"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "Maksepakkuja laadimine"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "Laadimine..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "Asukoht"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "Logi sisse"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Logi sisse Google'iga"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "Logi välja"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "Sisselogimine"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "Sisselogimise viga"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "Vaadake esmalt ringi"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "Madala saldo teavitus ei ole aktiivne, sest automaatne saldotäiendamine on sisse lülitatud."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "Madala saldo teavitused"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "Serveri üksikasjad"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "Server on klientidele viivitamatult rendiks saadaval."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "Klient kasutab serverit ja selle eest arvestatakse tasu."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "Klient on serveri tellinud, kuid see ei vasta nõutud konfiguratsioonile.<0/>Kui vajalik konfiguratsioon on tehtud, viige olekusse „kasutuses”."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "Server ei ole kättesaadav või vajab parandamist."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "Server vajab ketta puhastustoiminguid."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "Masinatüüp"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "Hooldus"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "Halda"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "Halda API võtmeid"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "Hallatav teenus"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "Hallatavad teenused"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "Maks. lisakasv"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "Maksimeeri"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "Maksimaalne üleslaaditava faili suurus on {maxFileSizeInMB} MB"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "Makseviis"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "Valideerimise järel kättesaadavad meetodid"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "Mõõdikud"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "Selle ressursi mõõdikuid ei laadita jõudluse kaalutlustel"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "MFA on teie kasutajal aktiivne."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "Minimeeri"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "Puudub"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "Režiim"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "kuu"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "Igakuine"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "Kuukulu"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "Rohkem üksikasju"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "Mitmefaktoriline autentimine (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "Puudub"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "Nimi"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "Nimi (vähemalt {minChars} märki)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "Nimi on liiga lühike"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "Kas vajate abi?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "Võrk"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "Võrgu ribalaius"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "Võrguliidesed"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "Võrk"

#: src/components/sidebar/SidebarList.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "Uus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "Uue faili nimi"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "Uus kaust"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "Uue kausta nimi"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "Uus võrk"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "Uus parool"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "Uus SSH-võti"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "NForce'i kliendi ID"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "Aktiivne kaart puudub"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "Andmed puuduvad"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "No Fail-over"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "Kellelgi ei ole teie kasutajakontole veel juurdepääsu."

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "Keegi pole teiega veel juurdepääsu jaganud"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "Praegu makset ei tehta. Makseviisi saate igal ajal muuta."

#: src/components/empty.tsx
msgid "No records"
msgstr "Kirjeid pole"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "Selle serveri jaoks ei ole broneeringu arveldustsükleid saadaval."

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "Tulemusi ei leitud"

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "Salvestusämbrite arv"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "Failide arv"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "Ressursside arv"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "Reeglite arv"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "Sõlm"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Node pool"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Node poolid"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "sõlmed"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "Märkus: Kui kustutate märkimisväärse arvu üksusi, võib kustutusprotsess viia ebajärjekindlasse olekusse, kus osa üksusi kustutatakse, teised aga jäävad alles. Sellisel juhul korrake palun sama toimingut uuesti."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "Märkus: Kui teie kaust sisaldab suurt hulka faile, võtab ümbernimetamine aega ja võib tekitada ebajärjepideva oleku, kus osa faile liigutatakse uude asukohta, samal ajal kui teised jäävad vanasse kausta. Sellisel juhul korrake toimingut ja nimetage sama kaust uuesti ümber."

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "Märkus! Omanik näeb, kas olete selle kutse vastu võtnud. Tal ei ole juurdepääsu teie kasutajakontole ega võimalust vaadata või muuta teie ressursse."

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "Teavitused"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "Teavita, kui saldo langeb alla"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "Teavitage, kui saldo langeb alla järgmise läve. Pange tähele, et tegelik piir on määratud baasvaluutas."

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "Nüüd saadaval"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "Võrguühenduseta"

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "Kord päevas"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "Korra nädalas (kolmapäeval kell 02:00 UTC)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "Ühel teie arvelduskontol on probleem ning teie salvestusämbrid on peatatud. Lisateabe saamiseks vaadake <0>arvelduskonto üksikasju</0> või võtke probleemi lahendamiseks ühendust toega."

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "Käimasolev"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "Jooksev saldo"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "Töötab"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "Ainult automaatselt tasutavad makseviisid"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "Luuakse ainult alglaadimisketas! See võib põhjustada seda, et opsüsteem ei käivitu korralikult, kui lähtehetktõmmise opsüsteemi seadistus eeldab täiendavate ketaste olemasolu."

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "Opsüsteem"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "Operatsioonisüsteemi automaatuuendus"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "Või"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "Tellimus"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "Tellimused"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "Opsüsteem"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "väljaminev"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "Väljaminevad reeglid"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "Väljuv liiklus on lubatud ainult määratud sihtkohtade määratud portidesse. Kõik muu liiklus blokeeritakse."

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "Tasumata summa"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "Tasutud"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "Parameetrid"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "Parool"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "Kasutaja parool. Peab sisaldama vähemalt ühte väike- ja ühte suurt ASCII-tähte (a-z, A-Z) ning vähemalt üht numbrit (0-9). Miinimumpikkus on 8 märki."

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "Paroolid ei ühti"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "Möödunud"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "Path-stiilis URL"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "Maksa"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "Maksa arve"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "Maksa kohe"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Pay the total charge amount of <0>{chargeAmount}</0> with EVC Mobile Money to get {creditAmount} credits. Enter your billing account ID <1>{billingAccountId}</1> as the payment reference."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "Jooksev maksmine (soovitatav)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
msgid "Paying by invoice"
msgstr "Arvega tasumine"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "Arvega tasumine (tagasi lükatud / peatatud)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "Arvega tasumine (ootel)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "Makse autoriseerimise kontroll on lõpetatud."

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "Makse tühistati"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "Makse tühistati kõrge riski tõttu"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "Makseandmed"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "Makse viga"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "Makse viga: {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "Makse ebaõnnestus"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment method"
msgstr "Makseviis"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "Makseviisid"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "Selle meetodiga võtab makse töötlemine aega. Ostetud krediit lisatakse teie kontole automaatselt, kui protsess on lõpule viidud."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "Maksetüüp"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "Makse tühistati"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "tk"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "Ootel"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "Periood"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "Õigused"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "Isikukood"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "Telefoninumber"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "Platvormi poolt pakutavad"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "Palun võtke teadmiseks, et arvelduskontot ei aktiveerita enne, kui administraator on teie taotluse heaks kiitnud."

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "Selle makseviisi kasutamiseks lubage hüpikaknad"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "Palun olge kannatlik"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "Palun viige makse lõpule hüpikaknas"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "Piirangu eemaldamiseks võtke ühendust toega."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "Lisateabe saamiseks võtke ühendust administraatoritega."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "Palun jätkake."

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "Palun sisestage kehtiv nimi"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "Palun sisestage oma e-posti aadress. Saadame teile e-kirja parooli lähtestamiseks."

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "Palun lõpetage e-posti aadressi lisamine"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "Pange tähele, et teie salvestusämbriga seotud arvelduskonto erineb teie salvestuskontoga seotud arvelduskontost. Arveldamise ühtsuse ja selgema halduse tagamiseks soovitame tungivalt need ühtlustada."

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "Palun vaadake, kuidas teie ressursi maksumus arvutatakse."

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "Valige VPC-võrk, millest soovite sihtserverid valida."

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "Palun valige loendist üks kirje"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "Palun laadige kinnitamiseks üles ettevõtte registreerimisdokumendi või ID-kaardi koopia (maksimaalselt {maxFileSizeInMB}MB)."

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "Sellel klastril hostitud podid ja teenused peatatakse ning ajutine salvestusruum kustutatakse."

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "Hüpikaken ei naasnud ümbersuunamiselt"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "Hüpikaken suleti enne, kui see jõudis laadida"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "Port"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "Port peab olema vahemikus 1 kuni 65535"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "Pordivahemik"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "PostgreSQL-i mitme sõlmega seadistus on Primary/Standby seadistus automaatse ümberlülitusega."

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "Ettemakstud ressursid"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "Ettemaks"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "Hind"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "Hinnakiri"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "Hind tsükli kohta"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "Hind tunnis"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "Hind kuus"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "Hinnad võivad allpool olevate valikute puhul erineda"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "Peamine"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "Privaatne"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "Privaatsed tõmmised"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "Privaatne IP-aadress"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "Privaatne IPv4"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "Privaatvõrk"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "Probleem PayPali API-ga."

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "Profiil"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "Protokoll"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "Esitage kehtiv cloud-config JSON- või YAML-vormingus. See konfiguratsioon edastatakse virtuaalmasinale cloud-init kasutajaandmetena. Kõikide saadaval olevate valikute kohta vaadake cloud-init dokumentatsiooni cloud-config kohta."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "Teenusepakkuja hooldusaja akna algus, mille jooksul pakkuja võib ajastada klastri automaatsed uuendused."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "Avalik"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "Avalikke IP-aadresse hallatakse võrgu vaates."

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "Avalik IPv4"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "Avalik IPv6"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "Avalik võti"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "SSH-võtmepaari avalik võti, mida kasutatakse virtuaalmasinasse sisselogimiseks. Peab olema formaadis <0>ssh-key-type base64encoded...key optional_comment</0>."

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "Avalik võrk"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "Avalik URL"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "Kogus"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "kvartal"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "Kvartaalne"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "RDP-link"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "Loe lähemalt"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "Ainult lugemiseks"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "Valmidus"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "Valmis"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "Taaskäivita"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "Hiljutised"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "Suunamine makselüüsile"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "Soovituskood"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "Soovituslink"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "Soovitamisprogramm"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Refresh credit"
msgstr ""

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "Värskenda olekut"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "Registrikood"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "Paigalda uuesti"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "\"{name}\" uuesti paigaldamine hävitab kõik andmed alglaadiskettal ja taastab selle algsesse puhtasse OS-i olekusse. Kõik hetktõmmised ja varukoopiad säilitatakse."

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "Laadi uuesti"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "Laadi andmed uuesti"

#: src/root.tsx
msgid "Reload page"
msgstr "Laadi leht uuesti"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "Järelejäänud krediit <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "Eemalda ressurss"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "Avaliku IPv4-aadressi seose eemaldamine sellelt ressursilt muudab ressursi avalikust internetist kättesaamatuks. IP-aadress jääb teie kontole reserveerituks. Avalikke IPv4-aadresse saate hallata vasakpoolses külgribas menüüst Võrk."

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "Kasutaja eemaldamine tühistab „{0}” õiguse tegutseda teie nimel."

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "Nimeta ümber"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "Aruanne"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "Aruanne {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "Aruanded"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "Taotletud"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "Broneeringud"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "Reserveeritud"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "Broneeritud ja ettemakstud kuni <0/> (jäänud {daysRemaining} päeva). Hind on esitatud kuupõhise ekvivalendina."

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "Lähtesta parool"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "Muuda suurust"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "Muuda ketta suurust"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "Suuruse muutmine on võimalik ainult siis, kui virtuaalmasin on peatatud."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "Ressursi nimi"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "Ressursid"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "sama VPC-võrgu ressursid, kasutades põhiliideste privaatseid aadresse"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "ressursid VPC-des, mida jagatakse VLANi alamliidestega, kasutades vastavaid privaatseid aadresse"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "Vastus võtab oodatust kauem aega. Oodake veidi ja värskendage lehte, et näha muudatusi. Tulemuseks võib olla nii õnnestumine kui ka ebaõnnestumine."

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "Vastus näib võtvat oodatust rohkem aega. Oodake veidi ja värskendage lehte, et näha makse oleku muutusi. Kui seda mõistliku aja jooksul ei juhtu, võtke ühendust kasutajatoega."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "Taasta"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "Taasta varukoopiast"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "Taasta hetketõmmisest"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "Varukoopiast taastamine kirjutab teenuse oleku üle valitud varukoopia olekuga."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "Selle varukoopia taastamine kirjutab praeguse oleku üle."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "Selle hetktõmmise taastamine kirjutab praeguse oleku üle."

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "Piiratud"

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "Säilitusaeg"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "Proovi uuesti"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "Viige oma pilveteenused AMD EPYCuga uuele tasemele"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "RNE dokument"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "Kõigi lisatud tulemüüride reeglid kombineeritakse; ühendus on lubatud, kui on vähemalt üks seda lubav reegel."

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "Käivitage oma rakendused füüsilistel serveritel, et tagada täielik kontroll, turvalisus ja puhas jõudlus. Tellige pühendatud server, mis on optimeeritud teie kõige nõudlikumateks kasutusjuhtudeks."

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "Töötab"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "S3-ga ühilduv objektisalvestus võimaldab teil salvestusressursse ilma ettemakseteta suurendada ja vähendada. Looge uus salvestuskonto, looge mõned salvestusämbrid ja alustage oma andmete skaleeritavat salvestamist – maksate vastavalt kasutusele."

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "Salvesta"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "Makseandmete salvestamine"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "Maksmiseks skaneerige QR-kood"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "Ulatus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "Otsi"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "Salajane juurdepääsuvõti"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "Valige fail"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "Valige makseviis"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "Valige suvand"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "Valige kuvatav valuuta, et näha hindu teile eelistatud valuutas. Kuvatud summad ja vahetuskursid on indikatiivsed ning ainult teabeks. Kõik tehingud töödeldakse aluseks olevas valuutas ({0}) ning lõplikud tasud võivad erineda sõltuvalt teie makseteenuse pakkuja määradest."

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "Valige eelistatud valuuta"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Saada Ctrl+Alt+Del"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "Saada e-post"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "Server"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "Serveri klass"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "Teenus"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "Teenuse nimi"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "Teenused"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "Määra vaikimisi"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "Määra objekti ACL väärtuseks 'private'"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "Määra objekti ACL väärtuseks 'public-read'"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "Jaga"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "Jaga Facebookis"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "Jaga LinkedInis"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "Jaga X-is"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "Jaga ajutiselt"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "Jagamise kestus"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "Näita"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "Kuva üksikasjad"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "Kuvatakse {limit} viimast üksust"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "Kuvatakse kataloogihinnad. Allahindlus rakendati kulude kokkuvõttes."

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "Registreeru"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Registreeru Google'iga"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "Suurus"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "Maht (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "Hetktõmmised"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "Jaga sotsiaalmeedias"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "Läbi müüdud"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "Sordi"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "Sordi järgi"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "Sordi kuupäeva järgi"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "Sordi nime järgi"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "Sordi suuruse järgi"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "Lähteport"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "Lähteport peab olema kordumatu"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "Allikad"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "SSH-võti ei vasta nõutud mustrile"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "SSH-võtmed"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "SSH-võtmeid saab hallata oma <0>kasutajaprofiili</0> all."

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "SSH-link"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "SSH-ühendus ei pruugi root-kasutajale olla saadaval opsüsteemi algseadistuse tõttu. Palun kasutage süsteemile juurdepääsuks virtuaalset konsooli ja tehke SSH-serveri seadistuses vajalikud muudatused."

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "Käivita"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "Alguskuupäev"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "Alusta siit"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "Alustage võrkude haldamist, luues uue võrguressursi."

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "Algusport"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "Algusport peab olema kordumatu"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "Alusta millegi uuega"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "Algusaeg"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "Makse alustamine"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "Osariik"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "Olek"

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "Peata"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "Peatatud"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "Peatamine"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "Salvestus"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "Salvestuse juurdepääsuvõtmed"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "Salvestuskonto"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "Salvestusämber"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "Salvestusämbri nimi"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "Salvestusämbrid"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "Tänava aadress"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "Sõne"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "Alamvõrgu vahemik (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "Vahesumma"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "Tugi"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "Peatatud"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "Lülitu ruudustikuvaatele"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "Lülitu loendivaatele"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "süsteem"

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "Looge hetktõmmis, et salvestada virtuaalmasina praegune olek. Hiljem saate hetktõmmist kasutada masina oleku taastamiseks või luua sellest uue virtuaalmasina muudetud suurusparameetritega."

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "Loo hetktõmmis"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "Tehke mõni toiming ja te ei näe seda kaktust enam kunagi."

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "Sihtport"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "Sihtserverid"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "Konsool"

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "Kasutustingimused"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "Teie ressursi tegelik maksumus arvutatakse allolevate hindade ja teie tegeliku tunnipõhise kasutuse alusel. Kõik hinnad on ühe ressursiühiku (1 vCPU või 1 GiB) kohta. Hinnad ei sisalda makse."

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "Arvelduskonto on suletud ega ole enam saadaval."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "Kampaaniakood aktiveeritakse alles pärast edukat saldo täiendamist."

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "Kogu kasutajaliides lülitub ümber ja käitub nii, nagu oleksite see kasutaja. Kui olete lõpetanud, saate seansi peatada, klõpsates päiseribal nuppu „Tagasi oma kontole” ning kasutajaliides lülitub tagasi teie kontole."

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "Lõplik vahetuskurss ja tasu suurus selguvad tegeliku makse tegemise hetkel."

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "Esimene saldo täiendamine avab teile tasuta krediidi summas <0><1/></0>."

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "Vorming on KK/AA"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "Link aegub:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "Nimi võib sisaldada ainult väiketähti, numbreid ja sidekriipse; see peab algama väiketähe või numbriga; lubatud pikkus on 3–63."

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "Parooli saab muuta mis tahes olemasoleva kasutajakonto jaoks."

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "Telefoninumber, kuhu probleemide korral ühendust võtta"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "Hind on ligikaudne, teie ressursi maksumus arvutatakse tegeliku tunnipõhise kasutuse alusel."

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "Parooli kordussisestus, et veenduda selle õigesti sisestamises."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "Valitud arvelduskontol ei ole selle broneeringu ostmiseks piisavalt krediiti."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "Valitud arvelduskonto on piiratud ega saa broneeringuid luua."

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "Alamvõrgu vahemik peab jääma ühte järgmistest IP-plokkidest:"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "Kasutajakonto, millele parool määratakse."

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "Teie e-posti aadressi kinnitamisel ilmnes viga."

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "Ressursi loomisel tekkis tõrge."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "Need tunnused on ainult esialgseks sisselogimiseks. Soovitatav on need kohe muuta."

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "See {resourceTypeName} on kadunud"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "Seda füüsilist serverit seadistatakse veel."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "Sellel arvelduskontol on ressursside loomisel piiratud võimalused."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "See arvelduskonto on piiratud"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "See distributsioon lisab litsentsitasu <0/> tunnis (<1/> kuus)."

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "See väli on kohustuslik"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "Sellel võtmel on juurdepääs kõigile selle salvestuskonto salvestusämbritele. Juurdepääsu piiramiseks kindlate salvestusämbritega looge eraldi salvestuskonto."

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "See leht on kadunud"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "See teenus on juurdepääsetav ainult samas VPC-võrgus olevatele ressurssidele, kasutades neid privaatseid aadresse."

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "See virtuaalmasin on ligipääsetav:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "See kustutab tulemüüri ja sellega seotud reeglid ning need ei kehti enam ühelegi määratud ressursile."

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "See lülitab teie ressursi \"{name}\" sunniviisiliselt välja. Peatatud ressursside puhul tuleb teil tasuda ainult salvestuse eest."

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "See paneb klastri \"{display_name}\" talveunne."

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "Seda kasutatakse ainult süsteemis, et kui teil on mitu kontot, oleks neid lihtne ära tunda."

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "See taaskäivitab teie ressursi \"{name}\"."

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "See eemaldab aadressi või vahemiku lubatud IP-aadresside loendist.<0/>Pange tähele, et tühi lubatud IP-aadresside loend lubab ühendused mis tahes aadressilt."

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "See peatab teie ressursi „{display_name}”. Kui korralik sulgemine ei lõppe 120 sekundi jooksul, tehakse jõuga peatamine. Peatatud ressursside eest arvestatakse tasu ainult salvestuse eest."

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "See lülitab teie ressursi \"{name}\" välja. Kui sujuv väljalülitamine ei lõpeta 120 sekundi jooksul, peatatakse ressurss sunniviisiliselt. Peatatud ressursside puhul tuleb teil tasuda ainult salvestuse eest."

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "See lõpetab liikluse edastamise sihtkohtadesse ja eemaldab koormusjaoturi."

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "Lävi"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "Aeg edasi liikuda. Siin on mõned ideed, kuhu edasi minna:"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "Aeg edasi liikuda. See üksus on kustutatud või teil puudub ligipääs."

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "Razorpay vastuse ootamise aeg sai läbi"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "Ajavöönd"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "Arvelduskonto aktiveerimiseks lisage palun makseviisina krediitkaart või võtke arvega tasumise lubamiseks ühendust toega."

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "Teenusele tehtavate ühenduste piiramiseks peate lisama lubatud IP-aadresside loendisse vähemalt ühe sissetuleva IP-aadressi (kõik muud avalikud ja privaatsed ühendused keelatakse). Võite määrata üksiku IPv4-aadressi või aadressiploki CIDR-notatsioonis (nt 1.1.1.0/24)."

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "Platvormi kasutamise alustamiseks peate kõigepealt seadistama arvelduskonto. Võite julgelt ringi vaadata, et süsteemiga tutvuda, ja naasta arvelduskonto loomise juurde siis, kui olete valmis oma esimesi ressursse looma."

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "Meie teenuste kasutamiseks peate nõustuma kasutustingimustega."

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "Märgis"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "Täienda saldot"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "Saldo täiendamise summa"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "Täiendage saldot vähemalt <0><1/></0>, et saada soovituskoodi boonus summas <2><3/></2>."

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "Lisa krediiti kohe"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "Lisa oma kontole krediiti"

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "Ettemaksuarved"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "Saldotäiendamise tellimused"

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "Kokku"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "Kogutasu"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "Kokku ilma {vatSymbol}-ta"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "Kõigi tasumata arvete summa. Sisaldab {vatSymbol}."

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "Kõigi tasumata tellimuste summa. Koos käibemaksuga."

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "Tehingutasu"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "Tüüp"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "UEFI muutujad (NVRAM) ei säili pärast taaskäivitamist."

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "Kasutajaliides"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "Eemalda seos"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "Määramata"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "Ühik"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "Tundmatu"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "Tundmatu Auth0 viga"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "Tundmatu arvelduskonto"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "Tundmatu makse viga{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "Tundmatu ressurss"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "Eemalda seos sihtserveriga"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "Tasumata"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "Tasumata summa"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "Kinnitamata"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "Uuenda"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "SSH-võtme uuendamine"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "Laadi üles"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "Laadige kontrolliks üles ainult RNE dokumendi koopia"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "Failide üleslaadimine"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "Üleslaadimised on veel pooleli. Kui lahkute sellelt lehelt, ei kuvata edenemist enam ning üleslaadimised võivad katkeda. Kas soovite siiski lahkuda?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "Kasutus"

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "Kasutage ISO-käivitusvalikut pärast virtuaalmasina loomist, et ise operatsioonisüsteem installida."

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "Juurdepääs"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "Kasutaja peab kutse oma profiilivaates vastu võtma"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "Kasutajavaade"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "Kasutaja e-posti aadress"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "Kasutajanimi"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "Kasutajad, kellele mul on juurdepääs"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "Kasutajad, kellel on ligipääs minu kontole"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "Kehtiv kuni"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "Kinnituse ootel"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "Väärtus ei vasta nõutud mustrile"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "Käibemaks"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "KMKR number"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "Kinnitatud"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "Kinnitatud makseviis puudub"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "Makseviisi kontrollimine"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "Versioon"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "Kuva"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "Kuva kõik kirjed"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "Kuva seadistuskäsud"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "Kuva üksikasjad"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "Kuva viimased {limit} kirjet"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "Kuva rohkem"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "Virtuaalhosti stiilis URL"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "Virtuaalmasin"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "VLAN ID"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "VPC IP-vahemik"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "VPC nimi"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "VPC-võrk"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "VPC-võrk on saadaval lisatasuta."

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "Oodake kinnitamist või lisage kaart"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "Makse kinnituse ootamine"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "Hüpikakna ümbersuunamiselt naasmise ootamine aegus"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "Ärkab"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "Hoiatus"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "Hoiatus: Enne alglaadisketta suuruse muutmist on soovitatav virtuaalmasin peatada."

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "Soovitame teie taotluse menetlemise ajal lisada krediitkaardi, et teenused kohe aktiveeruksid."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "Soovitame automaatset saldotäiendamist, sest see minimeerib vahendite lõppemise riski ja seeläbi mõju teie serveri ressurssidele."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "Oleme kokku pannud mõned lingid alustamiseks. Arendage, testige koodi ja juurutage oma rakendusi kiiresti – prototüüpimisest kuni suuremahulise arenduseni."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "Oleme saavutanud failibrauseri mahupiirangu. Kasutajaliidese stabiilsuse säilitamiseks oleme teie salvestusämbri sisu laadimise lõpetanud. Salvestusämbri sisu haldamiseks kasutage palun muid teile kättesaadavaid tööriistu."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "Tere tulemast"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "Tere tulemast!<0/>Meil on hea meel, et olete siin."

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "Mida soovite teha?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "Kui saldo langeb alla"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "Kui aadress on reserveeritud, kuid ressursile määramata, rakendub tasu <0/> / kuu."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "Kui see on valitud, luuakse teie ressursile avalik ujuv IPv4-aadress ja määratakse sellele automaatselt. Kui te ei soovi ressursile avalikku ligipääsu, saate valiku siin tühistada või eemaldada IP-aadressi hiljem."

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "Kui lubate varundusteenuse, luuakse käivitusketta (välja arvatud lisakettad) automaatne kettatasemel varukoopia. Varukoopia luuakse kord nädalas ja kuvatakse siin. Hiljem saate varukujutisi kasutada virtuaalmasina taastamiseks või luua varukoopiast uue virtuaalmasina muudetud suurusparameetritega."

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "Ülesande töötlemise ajal saate:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "Tulemüüriga saate kontrollida sissetulevat ja väljaminevat võrguliiklust eelmääratud turbereeglite alusel."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "Esimese arvelduskonto loomisel saate avada tasuta krediidi summas <0><1/></0>."

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "Valitud makseviisiga võetakse teilt tasu valuutas {0}."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "Ilma aktiivse arvelduskontota ei saa te ühtegi ressurssi luua; alustuseks looge üks."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "Ilma aktiivse arvelduskontota ei saa ressursse luua."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "aasta"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "Iga-aastane"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "Jah"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "Hakkate tegutsema kasutajana „{name}”"

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "Te olete administraator ja kavatsete delegeerida oma administratiivsed õigused teisele kasutajale. Palun veenduge, et see toiming on teadlik."

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "Turvalisuse tõstmiseks saate aktiveerida mitmefaktorilise autentimise. See töötab ainult kasutajanime-parooli sisselogimisviisi korral. Sotsiaalsete sisselogimisviiside (Google jne) puhul on MFA tavaliselt võimalik aktiveerida kolmanda osapoole juures."

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "Saate käivitada oma virtuaalmasina spetsiaalselt süsteemi taastamiseks või värske operatsioonisüsteemi installimiseks mõeldud tõmmiselt. Selle režiimi sisselülitamisel ühendatakse valitud tõmmis käivitusandmekandjana. Seejärel saate masinale ligi Konsooli kaudu. See käivitusrežiim kehtib ainult praeguse käivituse ajal. Järgmisel käivitamisel kasutab virtuaalmasin tavapärast käivitusrutiini."

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "Võite selle lehe sulgeda."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "Saate luua mitu arvelduskontot, millest igaüks on seotud konkreetsete makseviisidega. Nii saate kulusid tõhusalt eraldada ja jälgida eri meeskondade, osakondade või projektide lõikes."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "Saate alustada siit ja jätkata hiljem, klõpsates lingil e-kirjas, mille teile saadame."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "Jagades oma ainulaadset soovituskoodi, saate teenida ja anda tasuta krediiti."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "Te ei saa lisada uut broneeringut, sest tulevane broneering on juba olemas."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "Broneeringu kinnitamisel kohustute tasuma valitud perioodi täishinna."

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "Sellele ressursile on määratud ujuv IP-aadress <0>{0}</0>."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "Teil on aktiivne kampaaniakood (<0>{referralCode}</0>), millega saate lisaboonuse!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "Teil on arvelduskonto kinnitamine pooleli."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "Olete arvelduskonto kinnitamise protsessi lõpetanud. Palun oodake lõplikku otsust."

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "Teil pole teavitusi."

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "Pärast makse sooritamist võite selle akna sulgeda."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "Võite selle dialoogiakna praegu sulgeda."

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "Selles salvestusämbris failide sirvimiseks peab teil olema vähemalt üks juurdepääsuvõti."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "Kui kinnitamine on heaks kiidetud, saate seadistada makseviisid ja kasutada pilveteenuseid."

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "Kui kinnitamine on lõpetatud, saate seadistada makseviisid ja kasutada pilveteenuseid."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "Teilt tasu ei võeta enne, kui see on valmis."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "Teie konto on peatatud"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "Teie tegelik tasu on <0/>, vahetuskursiga <1/>."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "Teie arvelduskonto on peatatud. Lisateabe saamiseks vaadake arvelduskonto üksikasju ja probleemi lahendamiseks <0>võtke ühendust toega</0>."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "Teie arvelduskontole on krediiti lisatud"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "Arvelduskonto aktiveerimiseks peab saldo olema positiivne."

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "Teie e-posti aadress on edukalt kinnitatud. Nüüd saate sisse logida."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "Teie e-posti aadress on pärast kinnitamise alustamist muutunud. Palun alustage uuesti."

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "Teie valitud arvelduskontol on allahindlust {discount}%"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "Teie salvestusämber sisaldab märkimisväärsel hulgal faile ja oleme laadimise ajutiselt peatanud. Järgmise failipartii laadimise jätkamiseks klõpsake nuppu „Laadi veel”."

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "Postiindeks"
